import { fetchApi } from "./index";

export interface MentorStoryImage {
  key: string;
  url: string;
  order: number;
  eyebrow: string | null;
  header: string | null;
}

export interface MentorStory {
  id: string;
  mentor_id: string;
  story_type: "first_moment";
  images: MentorStoryImage[];
  created_at: string;
  updated_at: string;
}

export const getMentorStories = async (mentorId: string, storyType = "first_moment") => {
  const { data } = await fetchApi<MentorStory[]>({
    url: "/v2/mentor/stories",
    method: "GET",
    params: { type: storyType, mentorId },
  });
  return data;
};

export const getMentorStoryPresignedUrl = async (
  mentorId: string,
  filename: string,
  contentType: string,
) => {
  const { data } = await fetchApi<{ key: string; url: string; expiresIn: number }>({
    url: "/v2/mentor/stories/presigned-url",
    method: "GET",
    params: { filename, contentType, mentorId },
  });
  return data;
};

export const saveMentorStory = async (
  mentorId: string,
  body: { storyType: string; images: MentorStoryImage[] },
) => {
  const { data } = await fetchApi<MentorStory>({
    url: "/v2/mentor/stories",
    method: "POST",
    data: { ...body, mentorId },
  });
  return data;
};

export const deleteMentorStoryImage = async (mentorId: string, imageKey: string) => {
  const { data } = await fetchApi<MentorStory>({
    url: `/v2/mentor/stories/images/${encodeURIComponent(imageKey)}`,
    method: "DELETE",
    params: { mentorId, storyType: "first_moment" },
  });
  return data;
};
